import { logger } from 'packages';

/**
 *
 * @param {object} initData
 * @param {object} [initData.featureSwitches]
 * @param {object} [initData.startPageResponse]
 * @param {array} [initData.trendingBrands]
 * @param {array} [initData.trendingSearches]
 * @returns {{isFetching: boolean, hasResults: boolean, config: object, trendingBrands: array, trendingSearches: array}}
 */
export default initData => {
    let {
        featureSwitches,
        startPageResponse,
        trendingBrands = [],
        trendingSearches = []
    } = initData;
    let config;
    if (featureSwitches?.['start-page-contentful']) {
        if (startPageResponse?.config) {
            try {
                config = JSON.parse(startPageResponse.config);
            } catch (error) {
                logger(error);
            }
        }
    }
    return {
        isFetching: false,
        hasResult: config !== undefined,
        config,
        trendingBrands,
        trendingSearches
    };
};
